import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDiagnosticsComponentContext } from '../contexts/DiagnosticsComponentContext';
import Loader from '../components/Loader';
import { useEffect } from 'react';
import { useLLMDiagnose } from '../contexts/LLMDiagnoseContext';
import { WorkRouter } from '../routers/WorkRouter';
import { useDiagnosticComponentCallbacks } from '../hooks/useDiagnosticsComponentCallbacks';

export const DiagnosticsComponent = ({
  sessionId,
  searchParams,
}: {
  sessionId: string;
  searchParams: URLSearchParams;
}) => {
  useDiagnosticComponentCallbacks();
  const navigate = useNavigate();
  const { session, setSessionId, setSession, setSignature, setTimestamp } =
    useDiagnosticsComponentContext();
  const { setFreeText, setPatientInformation } = useLLMDiagnose();
  useEffect(() => {
    if (!sessionId) return;
    if (session && session.id === sessionId) return;
    setSession(null);
    setSessionId(sessionId);
    navigate(`/work/patient/test/visit/test/diagnoses`);
  }, [sessionId, setSession, setSessionId, navigate, session]);
  useEffect(() => {
    const signature = searchParams.get('signature');
    const timestamp = searchParams.get('timestamp');
    setSignature(signature || 'dummy');
    setTimestamp(timestamp || 'dummy');
  }, [searchParams, setSignature, setTimestamp]);

  useEffect(() => {
    if (!session) return;
    setFreeText(session.data.notes);
    setPatientInformation(session.data.patient);
  }, [session, setFreeText, setPatientInformation]);
  console.log('session', session);

  if (!session) {
    return <Loader showLoader={true} />;
  }
  return (
    <Routes>
      <Route path="work/*" element={<WorkRouter />} />
    </Routes>
  );
};
